import DialogBase from "../components/common/DialogBase";
import ReactDOM from 'react-dom';
import searchFormMap from "../components/common/searchformmap";
import { isEmpty, isNotEmpty } from "./util";
import rootScope from "../store/rootScopeStore";
import asyncService from "../services/common/asyncService";
import cldService from "../services/cld/cldService";
import errMsgService from "../services/common/errMsgService";
import dialogService from "../services/common/dialogService";
import { setTargetFocus } from "./directive-utils";
/**
* 元の入力項目にフォーカスを戻す
* 
* @param {any} targetName 
* @returns 
*/
export const focusBack = (targetName) => {

    setTimeout(() => {
        // setTargetFocus(isNotEmpty(targetName) ? targetName : beforeFocus);
    }, 0);
}

export const searchformOpen = (name, state, draggable) => async () => {
    // 既にモーダルが開いている場合はダミーを返す（画面側で設定しているイベント追加処理を空処理するため）
    // if (document.querySelector('.dialog-base-contailer')) return false;
    // モーダルオプションの設定
    const modalOptions = searchFormMap[name].modal;

    // modal画面移動可能フラグが設定されていない場合は移動可能状態に設定する
    draggable = isEmpty(draggable) ? true : draggable;
    modalOptions.draggable = draggable;
    modalOptions.backdrop = !draggable;
    modalOptions.state = state;
    return new Promise((resolve) => {
        const rootElement = document.getElementById('root');
        const divElement = document.createElement('div');
        divElement.classList.add('dialog-base-contailer');
        if (!modalOptions.backdrop) {
            divElement.classList.add('back-drop');
        } else {
            divElement.classList.remove('back-drop');
        }
        rootElement.appendChild(divElement);
        const modalInstanceResult = (result) => {
            resolve({ result });
        }
        ReactDOM.render(<DialogBase options={modalOptions} resultFunc={modalInstanceResult}></DialogBase>, divElement);
    })
}

export const goto = (screenId, mode) => {
    rootScope.footer = {};
    rootScope.navigate && rootScope.navigate(`${screenId}${!isNaN(mode) ? `/${mode}` : ''}`);
}

/**
* 画面IDから入力系, 帳票系の文字(F, R)を抽出する
* 
* @param {any} currentPage 
* @returns 
*/
export const frDelect = (currentPage) => {

    return currentPage.substr(3, 1);
}

/**
* 休日のチェック
* 
* @param {any} dispatch
* @param {any} errParams
* @param {any} targetName
* @param {any} date
* @returns 
*/
export const checkDayOff = (dispatch, errParams, targetName, date, callback, params) => {
    // 【WebAPIの呼び出し】プリザンターの営業日カレンダー情報取得IF(clda001)を呼び出す。
    dispatch(asyncService.async(cldService.cld001(date), (result) => {
        const obj = {
            name: errParams,
        }
        errMsgService.delMsgLabel(obj);

        // プリザンターの営業休日日だった場合、エラーメッセージを表示
        if (result.data.response.data.length) {
            // メッセージを表示する
            errMsgService.addMsgLabel("ECMN0700", obj);
            //return true;
        } else if (isNotEmpty(callback)) {
            callback(params);
        }
        //return false;
    }));
}

export const checkDayOffConfirm = (dispatch, errParams, targetName, date, callback, params) => {
    // 【WebAPIの呼び出し】プリザンターの営業日カレンダー情報取得IF(clda001)を呼び出す。
    dispatch(asyncService.async(cldService.cld001(date), (result) => {
        errMsgService.delMsgKey(targetName);
        if (result.data.response.data.length) {
            // メッセージを表示する
            dialogService.okDialog("WCMN0050", null, [errParams]);
        } else if (isNotEmpty(callback)) {
            callback(params);
        }
    }));
}

